import styled from '@emotion/styled';

export const Container = styled.div`
  position: relative;
  height: 200px;
  min-width: 250px;
`;
